
export default {
  props: {
    tipstype: {
      type: String,
      default: ''
    },
    ourl: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    tips: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  },
  mounted() {
    // this.setele()
  },
  methods: {
    setele() {
      const ele = document.querySelectorAll('#tipscontent p')
      for (let i = 0; i < ele.length; i++) {
        if (ele[i].querySelector('span')) {
          ele[i].querySelector('span').innerHTML = `<i style="display: inline-block">${i + 1}.</i>&nbsp;` + ele[i].querySelector('span').textContent
        } else {
          ele[i].style.display = 'none'
        }
      }
    },
    open() {
      this.show = true
      // this.$nextTick(() => {
      //   this.setele()
      // })
    },
    closeall () {
      this.$emit('close')
    },
    close() {
      this.show = false
      window.open(this.ourl)
      // this.$emit('close')
      // this.$emit('iframeif', this.tipstype)
    }
  }
}
